import { Carousel, CarouselSlide } from '@mantine/carousel';
import { Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { playerPageModel, PlayerPageTabValues } from 'pages/player-page/model';
import { PlayerPageInfo } from '../player-page-info';
import { PlayerPageTransactions } from '../player-page-transactions';
import cls from './player-page-tabs.module.scss';

export const PlayerPageTabs = () => {
	const { t } = useTranslation();

	const { value, setValue } = useUnit(playerPageModel.currentTabState);

	return (
		<Tabs
			variant='default'
			keepMounted={false}
			classNames={{
				root: cls.playerPageTabs,
				panel: cls.playerPageTabsPanel,
				list: cls.playerPageTabsList,
			}}
			defaultValue='info'
			value={value}
			onChange={(v) => setValue(v as PlayerPageTabValues)}
		>
			<Tabs.List>
				<Carousel
					slideSize='auto'
					emblaOptions={{ dragFree: true }}
				>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='player-page-info-tab'
							value='info'
						>
							{t('player-page.info')}
						</Tabs.Tab>
					</CarouselSlide>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='player-page-transactions-tab'
							value='transactions'
						>
							{t('player-page.transactions')}
						</Tabs.Tab>
					</CarouselSlide>
				</Carousel>
			</Tabs.List>
			<Tabs.Panel value='info'>
				<PlayerPageInfo />
			</Tabs.Panel>
			<Tabs.Panel value='transactions'>
				<PlayerPageTransactions />
			</Tabs.Panel>
		</Tabs>
	);
};
